import React from "react";
import styled, { useTheme } from "styled-components/native";
import RadioButton from "@components/atoms/RadioButton";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTranslation } from "react-i18next";
import { Diamond } from "@src/types/DiamondDetail";
import { PairShareOption } from "../types";
import { SpaceType } from "@components/atoms/Spacer/types";
import { Spacer } from "@components/atoms";

type PairShareSelectionProps = {
  item: Diamond;
  selectedOption: PairShareOption;
  onOptionChange: (option: PairShareOption) => void;
};

const PairShareSelection: React.FC<PairShareSelectionProps> = ({
  item,
  selectedOption,
  onOptionChange,
}) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();

  const children = item?.children ?? [];
  const childCount = children.length;

  const stone1StockNum = children[0]?.stock_num ?? "";
  const stone2StockNum = children[1]?.stock_num ?? "";
  ("productDetailPage.stockNum.pair.text");
  const options = [
    {
      value: PairShareOption.PAIR,
      label: t("shareScreen.pairShare.sharePair.text", {
        defaultValue: `Share Pair ({{count}} stones)`,
        count: childCount,
      }),
    },
    {
      value: PairShareOption.STONE_1,
      label: t("shareScreen.pairShare.shareStone.text", {
        defaultValue: `Share only {{stockLabel}} {{stockNum}}`,
        stockLabel: t("productDetailPage.stockNum.pair.text", "Stock#"),
        stockNum: stone1StockNum,
      }),
    },
    {
      value: PairShareOption.STONE_2,
      label: t("shareScreen.pairShare.shareStone.text", {
        defaultValue: `Share only {{stockLabel}} {{stockNum}}`,
        stockLabel: t("productDetailPage.stockNum.pair.text", "Stock#"),
        stockNum: stone2StockNum,
      }),
    },
  ];

  const availableOptions = options.filter((option, index) => {
    if (index === 0) return true;
    if (index === 1) return children.length >= 1;
    if (index === 2) return children.length >= 2;
    return false;
  });

  return (
    <Container>
      {availableOptions.map((option, index) => (
        <>
          <RadioButton
            key={option.value}
            label={option.label}
            checked={selectedOption === option.value}
            onPress={() => onOptionChange(option.value)}
            labelColor={
              selectedOption === option.value
                ? theme["core-05"]
                : theme["core-06"]
            }
            styles={
              selectedOption === option.value
                ? typography["H3-M"]
                : typography["H3-R"]
            }
            margin="0px"
          />
          {index < availableOptions.length - 1 && (
            <Spacer size={SpaceType.Basic} />
          )}
        </>
      ))}
    </Container>
  );
};

const Container = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: 8px;
  padding: ${SpaceType.Double}px;
  margin-bottom: ${SpaceType.large}px;
`;

export default PairShareSelection;
